<template>
  <div>
    <article class="bg-w">
      <div class="">
        <div v-for="(item, index) in config" class="line" :key="index">
          <h1 class="tit">{{item.name}}</h1>
          <div v-for="(v, i) in item.params" :key="i"  class="lineB">
          <cell :title="v.name" class="tagQreport">
            <span slot="value">{{v.value}}</span>
          </cell>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import {
  Cell
} from '@lx-frontend/cvux'
import { evaluate } from './restConfig'
export default {
  components: {
    Cell
  },
  data() {
    return {
      config: []
    }
  },
  created() {
    let type = 'default'
    // 请求接口说明：
    // 线索询价和车辆询价来路的：查看都是调用 default 的请求接口
    // 询价撮合、流拍撮合：auctionMatch、enquiryMatch、outbound、outBoundReview
    // 拍卖来路：aution
    const fromArr = ['auctionMatch', 'enquiryMatch', 'auction', 'outbound', 'outBoundReview', 'reference', 'ownbrand']
    // 增加参数 default 来区别来源页面 是从全部车辆拍卖页面来的 还是询价页面来的
    if (this.$route.query.default !== '1') {
      fromArr.map((item) => {
        if (item === this.$route.params.source) {
          type = item
        }
      })
    }
    this.getData(type)
  },
  methods: {
    async getData(type) {
      let id = this.$route.params.id
      let _this = this
      const sourctType = {
        // 流拍撮合查看报告接口
        'auctionMatch': function() {
          return _this.$rest.match.getMatchCarDetail(null, id)
        },
        // 询价撮合查看报告接口
        'enquiryMatch': function() {
          let postLink = `${id}/match_car_details`
          return _this.$rest.match.getEnquiryCarDetail(null, postLink)
        },
        // 拍卖报告接口
        'auction': function() {
          return _this.$rest.auction.getAuctionDetail(null, `${id}/detail`)
        },
        // 报废、零售、批售、特殊出库的查看报告
        'outbound': function() {
          return _this.$rest.outBound.getOutBoundCarDetail(null, `outbound_car_detail/${id}`)
        },
        // 出库审核中 查看报告
        'outBoundReview': function() {
          return _this.$rest.outBound.getOutBoundCarDetail(null, `outbound_requests/${id}/car_details`)
        },
        'reference': function() {
          return _this.$rest.usedCar.getReferenceCarDetail(null, `${id}`)
        },
        'ownbrand': function () {
          return _this.$rest.usedCar.getSharedCarDetail(null, `${id}`)
        },
        // 默认 车辆询价线索询价
        'default': function () {
          let source = _this.$route.params.source
          let urlLeft = evaluate[source](id)
          return _this.$rest.carInfo.query(null, urlLeft)
        }
      }
      let res = await sourctType[type]()
      if (res.code === 0) {
        this.config = type === 'default' ? res.data.car_info.info.config : res.data.auction_car.car_info.info.config
      } else {
        this.showToast(res.message)
      }
    }
  }
}
</script>
<style lang="less">
  @import "../../../stylesheets/modules/manage/qreport.less";
  .tagQreport .weui_cell_primary {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 20px;
    & > p {
      color: #888;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

</style>
